import { useState } from "react";
import { isMobile } from "@/utils";
import { Head } from "@inertiajs/react";
import MainLayout from "@/Layouts/MainLayout";
import SkincareComponent from "@/Components/SkincareComponent";
import InstructionsModal from "@/Components/InstructionsModal";
import ChangeDeviceModal from "@/Components/ChangeDeviceModal";
import FormComponent from "@/Components/FormComponent";

/**
 * SkincareTest is a functional React component that initializes the rendering
 * of the skincare analysis, receives the results from the SkincareComponent
 * and redirects to the form page
 *
 * @param {Object} props
 */
export default function SkincareTest({ qr, concerns }) {
    const [step, setStep] = useState(0);
    const [results, setResults] = useState({});
    const [isOpen, setIsOpen] = useState(isMobile());
    const [changeToMobileDeviceModal, setChangeToMobileDeviceModal] = useState(
        !isMobile(),
    );

    /**
     * Closes the InstructionsModal component by setting its isOpen state to false
     */
    function closeModal() {
        setIsOpen(false);
    }

    /**
     * Handles the event triggered when the scan finishes by storing the
     * returned data and changes to the next step (FormComponent)
     *
     * @param {Object} results - An object containing the YMK analysis results
     */
    async function handleScanFinish(results) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: "CompletePhoto",
            eventCategory: "SkinTest",
            eventAction: "Resultados",
            eventLabel: "Resultados preliminares",
        });

        setResults(results);
        setStep(1);
    }

    const parsedConcerns = concerns.map((concern) => {
        const resultsData = results.results || {};
        const score = resultsData[concern.slug];
        const scaledScore = score / 10;
        const roundedScore = Math.round(scaledScore * 100) / 100;
        return { ...concern, score: roundedScore };
    });

    return (
        <MainLayout>
            <Head title="Test" />

            {
              step === 0 && (
                <div>
                    <div className="flex w-full justify-center pb-24">
                        <SkincareComponent
                          onScanFinish={handleScanFinish}
                          setIsOpen={setIsOpen}
                        />
                    </div>

                    <InstructionsModal isOpen={isOpen} closeModal={closeModal} />
                    <ChangeDeviceModal
                      isOpen={changeToMobileDeviceModal}
                      closeModal={() => {
                          setChangeToMobileDeviceModal(false);
                      }}
                      qr={qr}
                    />
                </div>
              )
            }

            {
              step === 1 && (
                <FormComponent concerns={parsedConcerns} results={results} />
              )
            }
        </MainLayout>
    );
}
